import type { ReactNode } from 'react'

import { JobsContext } from './context'
import { useJobs } from './useJobs'

/**
 * Mounted inside the signed-in tree only. Polling the queue for someone who is
 * not signed in would be a stream of 401s.
 */
export function JobsProvider({ children }: { children: ReactNode }) {
  const value = useJobs()
  return <JobsContext.Provider value={value}>{children}</JobsContext.Provider>
}
